const dismissPatterns = [
    /postles:\/\/dismiss/,
    /\bdismiss\s*\(/,
]

export const hasDismissAction = (html?: string) => dismissPatterns.some(pattern => pattern.test(html ?? ''))
